// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".responsive-image[data-v-1026bbc0]{height:auto;width:100%}.transition-image[data-v-1026bbc0]{opacity:0;transition:opacity .2s var(--g-animation-easing)}.transition-image.loaded[data-v-1026bbc0]{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
